module.exports = __webpack_public_path__ + "static/media/ride.0ec1157d.ogg";